<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
    <div class="page-card-body" ref="pageRoot">
      <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
        <el-input v-model="keyword" placeholder="公司编码/公司名称/负责人 联系方式" style="width:300px" clearable @keyup.enter.native="onSearch" />
        <el-select v-model="status" placeholder="状态" clearable style="width:160px" @change="onFilterChange">
          <el-option label="已审核" :value="1" />
          <el-option label="待审核" :value="2" />
          <el-option label="已禁用" :value="3" />
        </el-select>
        <el-select v-model="type" placeholder="类型" clearable style="width:220px" @change="onFilterChange">
          <el-option label="线上商旅企业（OTA）" :value="1" />
          <el-option label="运输公司" :value="2" />
          <el-option label="候机楼（TMC）" :value="3" />
        </el-select>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button type="primary" @click="openCreate">新增合作商</el-button>
        <el-button @click="load(1)">刷新</el-button>
      </div>

      <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
        <el-table-column prop="code" label="公司编码" width="140" />
        <el-table-column prop="name" label="公司名称" min-width="180" />
        <el-table-column prop="type" label="类型" width="180">
          <template slot-scope="s">
            {{ typeLabel(s.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="leader" label="负责人" width="120" />
        <el-table-column prop="leaderPhone" label="负责人电话" width="140" />
        <el-table-column prop="phone" label="联系方式" width="140" />
        <el-table-column prop="status" label="状态" width="110">
          <template slot-scope="s">
            <el-tag :type="statusTagType(s.row.status)">{{ statusLabel(s.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="s">
            <el-dropdown v-if="canGenerateQrcode(s.row)" trigger="click" @command="(cmd) => handleQrcodeCommand(cmd, s.row)">
              <el-button type="text">二维码</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="view">查看二维码</el-dropdown-item>
                <el-dropdown-item command="gen">生成二维码</el-dropdown-item>
                <el-dropdown-item command="del">删除二维码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444" @click="remove(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div ref="pagerBar" class="pager-bar">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page.sync="pageNum"
          :page-size="pageSize"
          :total="total"
          @current-change="load"
        />
      </div>
    </div>

    <el-dialog :title="form.id?'编辑合作商':'新增合作商'" :visible.sync="dlg" width="560px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="公司编码">
          <div style="display:flex;gap:8px;align-items:center;">
            <el-input
              v-model="form.code"
              maxlength="10"
              placeholder="点击右侧按钮生成"
              autocomplete="off"
              :disabled="!!form.id"
              @blur="normalizeCode"
              style="flex:1"
            />
            <el-button :disabled="!!form.id" @click="generateCode">生成</el-button>
          </div>
          <div v-if="!!form.id" style="margin-top:6px;color:#94a3b8;font-size:12px;line-height:1.2;">
            公司编码创建后不可修改
          </div>
        </el-form-item>
        <el-form-item label="公司名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" style="width:100%">
            <el-option label="线上商旅企业（OTA）" :value="1" />
            <el-option label="运输公司" :value="2" />
            <el-option label="候机楼（TMC）" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人"><el-input v-model="form.leader" /></el-form-item>
        <el-form-item label="负责人电话"><el-input v-model="form.leaderPhone" /></el-form-item>
        <el-form-item label="联系方式"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="已审核" :value="1" />
            <el-option label="待审核" :value="2" />
            <el-option label="已禁用" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="微信二维码" :visible.sync="qrDlg" width="420px">
      <div v-loading="qrLoading" style="text-align:center;">
        <img
          v-if="qrImageSrc"
          :src="qrImageSrc"
          style="max-width:280px;max-height:280px;width:auto;height:auto;object-fit:contain;border:1px solid #ebeef5;border-radius:8px;"
        />
        <div v-if="qrCode" style="margin-top:10px;">code：{{ qrCode }}</div>
        <div v-if="qrPath" style="margin-top:4px;color:#909399;font-size:12px;word-break:break-all;">{{ qrPath }}</div>
      </div>
      <span slot="footer">
        <el-button @click="qrDlg=false">关闭</el-button>
      </span>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'BizPartner',
  mixins: [tableAutoHeight],
  data() {
    return {
      keyword: '',
      status: null,
      type: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dlg: false,
      saving: false,
      form: { id: '', code: '', name: '', type: 1, leader: '', leaderPhone: '', phone: '', status: 1 },
      qrDlg: false,
      qrLoading: false,
      qrImageSrc: '',
      qrPath: '',
      qrCode: '',
      qrPartnerId: ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    onSearch() {
      this.pageNum = 1
      this.load(1)
    },
    onFilterChange() {
      this.pageNum = 1
      this.load(1)
    },
    statusLabel(v) {
      if (v === 1) return '已审核'
      if (v === 2) return '待审核'
      if (v === 3) return '已禁用'
      return '-'
    },
    statusTagType(v) {
      if (v === 1) return 'success'
      if (v === 2) return 'warning'
      if (v === 3) return 'danger'
      return 'info'
    },
    typeLabel(v) {
      if (v === 1) return '线上商旅企业（OTA）'
      if (v === 2) return '运输公司'
      if (v === 3) return '候机楼（TMC）'
      return '-'
    },
    canGenerateQrcode(row) {
      const partnerType = Number(row && row.type)
      return partnerType === 1 || partnerType === 3
    },
    normalizeCode() {
      const raw = (this.form.code || '').toString().toUpperCase()
      // 只保留大写字母与数字，并截取到10位
      this.form.code = raw.replace(/[^A-Z0-9]/g, '').slice(0, 10)
    },
    generateCode() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let out = ''
      for (let i = 0; i < 10; i++) {
        out += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.form.code = out
    },
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/biz/partner/page', { params: { keyword: this.keyword, status: this.status, type: this.type, pageNum: this.pageNum, pageSize: this.pageSize } })
      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    openCreate() {
      this.form = { id: '', code: '', name: '', type: 1, leader: '', leaderPhone: '', phone: '', status: 1 }
      this.dlg = true
    },
    openEdit(row) {
      this.form = { ...row }
      if (this.form.type == null) this.form.type = 1
      if (this.form.status == null) this.form.status = 1
      this.dlg = true
    },
    async save() {
      if (this.saving) return
      this.saving = true
      try {
        this.normalizeCode()
        if (this.form.id) {
          await request.put('/admin/api/biz/partner/' + this.form.id, this.form)
        } else {
          await request.post('/admin/api/biz/partner', this.form)
        }
        this.$message.success('已保存')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    },
    async remove(row) {
      await this.$confirm('确认删除该合作商？', '提示', { type: 'warning' })
      await request.delete('/admin/api/biz/partner/' + row.id)
      this.$message.success('已删除')
      await this.load()
    },
    async handleQrcodeCommand(cmd, row) {
      if (cmd === 'view') return this.viewWxQrcode(row)
      if (cmd === 'gen') return this.generateWxQrcode(row)
      if (cmd === 'del') return this.deleteWxQrcode(row)
    },
    async viewWxQrcode(row) {
      this.qrDlg = true
      this.qrLoading = true
      this.qrImageSrc = ''
      this.qrPath = ''
      this.qrCode = ''
      this.qrPartnerId = row.id
      try {
        const data = await request.get('/admin/api/biz/partner/' + row.id + '/wx-qrcode')
        this.qrCode = data.code || ''
        this.qrPath = data.path || ''
        this.qrImageSrc = data.imageUrl || ''
      } finally {
        this.qrLoading = false
      }
    },
    async generateWxQrcode(row) {
      if (!this.canGenerateQrcode(row)) {
        this.$message.warning('仅线上商旅企业（OTA）和候机楼（TMC）支持生成二维码')
        return
      }
      this.qrDlg = true
      this.qrLoading = true
      this.qrImageSrc = ''
      this.qrPath = ''
      this.qrCode = ''
      this.qrPartnerId = row.id
      try {
        const data = await request.post('/admin/api/biz/partner/' + row.id + '/wx-qrcode')
        this.qrCode = data.code || ''
        this.qrPath = data.path || ''
        this.qrImageSrc = data.imageUrl || ''
        this.$message.success('二维码生成成功')
      } finally {
        this.qrLoading = false
      }
    },
    async deleteWxQrcode(row) {
      await this.$confirm('确认删除该合作商二维码？', '提示', { type: 'warning' })
      await request.delete('/admin/api/biz/partner/' + row.id + '/wx-qrcode')
      this.$message.success('二维码已删除')
      if (this.qrPartnerId === row.id) {
        this.qrImageSrc = ''
        this.qrPath = ''
        this.qrCode = ''
        this.qrDlg = false
      }
    },
    async openWxQrcode(row) {
      // 兼容旧调用，转发到查看
      await this.viewWxQrcode(row)
    },
    async generateWxQrcodeInDialog() {
      if (!this.qrPartnerId) return
      await this.generateWxQrcode({ id: this.qrPartnerId })
    },
    async deleteWxQrcodeInDialog() {
      if (!this.qrPartnerId) return
      await this.deleteWxQrcode({ id: this.qrPartnerId })
    },
    closeQrDialog() {
      this.qrDlg = false
      this.qrPartnerId = ''
      this.qrImageSrc = ''
      this.qrPath = ''
      this.qrCode = ''
    }
  }
}
</script>
